webpackJsonp([70144966829960],{

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  form {\n    margin-top: 3rem;\n    display: grid;\n    grid-gap: 1rem;\n    justify-content: center;\n  }\n'], ['\n  form {\n    margin-top: 3rem;\n    display: grid;\n    grid-gap: 1rem;\n    justify-content: center;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(20);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ContactStyled = _styledComponents2.default.section(_templateObject);
	
	var ContactPage = function ContactPage() {
	  return _react2.default.createElement(
	    ContactStyled,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Contact - Roberto V\xE1zquez Gonz\xE1lez Site' }),
	    _react2.default.createElement(
	      'h2',
	      { className: 'general__pageTitle' },
	      'Contact Me'
	    ),
	    _react2.default.createElement(
	      'article',
	      null,
	      'If you have any questions about my professional experience and/or skills or just want to to get in touch, do not hesitate to use the following form.'
	    ),
	    _react2.default.createElement(
	      'form',
	      { name: 'contactMe', method: 'post', action: '/thanks/', 'data-netlify': 'true' },
	      _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contactMe' }),
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'name' },
	        'Name'
	      ),
	      _react2.default.createElement('input', { name: 'name', type: 'text', autoComplete: 'name', placeholder: 'What\'s your name?', required: true }),
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'email' },
	        'Email'
	      ),
	      _react2.default.createElement('input', {
	        name: 'email',
	        type: 'email',
	        autoComplete: 'email',
	        placeholder: 'And your email?',
	        required: true
	      }),
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'message' },
	        'Message'
	      ),
	      _react2.default.createElement('textarea', {
	        name: 'message',
	        cols: '30',
	        rows: '10',
	        placeholder: 'What do you want to say?',
	        required: true
	      }),
	      _react2.default.createElement('div', { 'data-netlify-recaptcha': true }),
	      _react2.default.createElement(
	        'button',
	        null,
	        'Send it!'
	      )
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-6b68bfa3a316826419b5.js